const datosPaginacion = {
  pageSize: 0,
  totalPage: 0,
  tablaBody: "",
  prestacionesPP: [],
};

export default datosPaginacion;
